export default __webpack_public_path__ + "static/media/collage1.c47bb0d2.webp";